import {
  Box, TextField
} from "@mui/material";
import { useTranslate } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState } from "react";

export const UserCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const translate = useTranslate();
  const [password, setPassword] = useState('')
  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("nickname", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.nickname}
          helperText={(errors as any)?.nickname?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="string"
          label="Nickname"
          name="nickname"
        />
        <TextField
          {...register("email", {
            required: "This field is required",
          })}
          error={!!errors.email}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="email"
          label="Email"
          name="email"
          onChange={(e)=>{
            if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e.target.value) && e.target.value !== ''){
                setError('email', { type: 'custom', message: 'Invalid email address' });
            }
            else {
                clearErrors('email');
            }
          }}
        />
        <TextField
          {...register("password", {
            required: "This field is required",
          })}
          error={!!errors.password}
          helperText={(errors as any)?.password?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="password"
          label={translate("pages.register.fields.password", "Password")}
          name="password"
          onChange={(e)=>{
            if(!/^\w{8,}$/.test(e.target.value) && e.target.value !== ''){
                setError('password', { type: 'custom', message: 'Input at least 8 characters of alphabetas, numbers or underscores' });
            }
            else {
                clearErrors('password');
            }
            setPassword(e.target.value)
          }}
        />
        <TextField
          {...register("password_confirmation", {
            required: "This field is required",
          })}
          error={!!errors.password_confirmation}
          helperText="Password confirmation should match password"
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="password"
          label="Password Confirmation"
          name="password_confirmation"
          onChange={(e)=>{
            if(e.target.value !== password && e.target.value !== ''){
                setError('password_confirmation', { type: 'custom', message: 'Password confirmation does not match password' });
            }
            else {
                clearErrors('password_confirmation');
            }
          }}
        />
      </Box>
    </Create>
  );
};
